<template>
  <div id="payment-summary-card" class="card-item check-content">
    <h3 class="text-align-center">Verifica tu transacción</h3>
    <div class="check-content">
      <div class="subtitle-content">
        <div class="resume-item">
          <span class="subtitle-resumen">Resumen</span>
          <div class="resume-text">
            <p v-for="(operation, operationId, i) in paymentsMap" :key="`operation${i}`">
              <span v-show="operation.length" class="credit-info">Crédito hipotecario N°{{ i + 1 }}</span>
              <span
                v-for="(payment, j) in paymentsMap[operationId]"
                :key="`payment${i}${j}`"
                class="fee-info">
                Cuota
                {{ payment.paymentNumber +'/'+
                  debt.filter(operation => operation.operationId == operationId)[0].termAsMonths }}:
                <strong>$ {{ new Intl.NumberFormat('de-DE').format(payment.secondaryCurrencyTotalMonthlyPayment) }}</strong>
              </span>
            </p>
          </div>
        </div>
        <div class="details-item">
          <span class="subtitle-resumen">Detalle de la transacción</span>
          <div class="details-text">
            <table class="pay-resume">
              <tr
                v-for="(value, key, index) in transactionDataTitles"
                v-show="transactionData[key]"
                :key="`title-${index}`">
                <td class="pay-info">{{ value }}:</td>
                <td />
                <td class="fee-info">{{ transactionData[key] }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="amount-resume">
        <span class="total">Total pagado</span>
        <span class="amount-total">{{ transactionData.total }}</span>
      </div>
      <div class="download-end">
        <router-link class="button is-button-primary transition-fast" to="/">Finalizar</router-link>
      </div>
      <div class="stamp">
        <img src="@/ui/assets/img/stamp.svg">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Check',
  data() {
    return {
      debt: this.$store.state.paymentsModule.debt,
      paymentsMap: this.$store.state.paymentsModule.paymentsMap,
      transactionData: this.$store.state.paymentsModule.transactionData,
      transactionDataTitles: {
        transactionId: 'Id. de transacción',
        date: 'Fecha',
        paymentsMethodName: 'Medio de pago',
        subTotal: 'Sub total',
        usedClientBalance: 'Saldo utilizado',
        comment: 'Comentario',
        bankName: 'Banco'
      }
    };
  },
  mounted() {
    this.$store.dispatch('clearPaymentData');
  }
};
</script>
<style scoped>
.check-content {
  width: 80%;
  margin: 20px auto;
  padding-bottom: 5px;
  align-content: center;
}
.check-content .subtitle-content {
  text-align: center;
  margin: auto;
  width: 80%;
}
.subtitle-content .subtitle-resumen {
  text-align: left;
  font-size: 16px;
  margin-top: auto;
}
.check-content .subtitle-content .resume-item .resume-text {
  text-align: left;
  width: 80%;
  margin: 0px auto 10px;
}
.check-content .subtitle-content .resume-item .resume-text .credit-info {
  font-size: 12px;
  color: var(--primary);
  text-align: left;
}
.check-content .subtitle-content .resume-item .resume-text .fee-info {
  font-size: 12px;
  text-align: left;
  display: block;
}
.check-content .subtitle-content .details-item .details-text {
  display: flex;
  width: 80%;
  margin: 10px auto;
}
.check-content
  .subtitle-content
  .details-item
  .details-text
  .pay-resume
  .pay-info {
  font-size: 12px;
  color: var(--primary);
  text-align: left;
  margin: 0px 0px 5px;
  display: block;
  padding-right: 10px;
}
.check-content
  .subtitle-content
  .details-item
  .details-text
  .pay-resume
  .fee-info {
  font-size: 12px;
  margin-bottom: 5px;
  margin-left: 10px;
  color: var(--color-coal);
}
.check-content .amount-resume {
  text-align: center;
  margin-top: 10px;
}
.check-content .amount-resume .total {
  font-size: 18px;
}
.check-content .amount-resume .amount-total {
  color: var(--secondary);
}
.check-content .download-end {
  margin: 20px auto;
  display: block;
  text-align: center;
}
.check-content .stamp {
  position: absolute;
  max-width: 10%;
  bottom: 30px;
  right: 30px;
}

@media (max-width: 1255px) {
  .check-content .subtitle-content {
    width: 100%;
  }
}
@media (max-width: 1055px) {
  .check-content {
    width: 95%;
  }
  .check-content .subtitle-content {
    width: 80%;
  }
  .check-content .download-end {
    width: 50%;
  }
}
@media (max-width: 930px) {
  .check-content .subtitle-content {
    width: 95%;
  }
}
@media (max-width: 815px) {
  .check-content .subtitle-content {
    width: 90%;
  }
  .subtitle-content .subtitle-resumen {
    font-size: 14px;
  }
  .check-content .subtitle-content .resume-item .resume-text .credit-info {
    font-size: 10px;
  }
  .check-content .subtitle-content .resume-item .resume-text .fee-info {
    font-size: 10px;
  }
  .check-content
    .subtitle-content
    .details-item
    .details-text
    .pay-resume
    .fee-info {
    font-size: 10px;
  }
  .check-content
    .subtitle-content
    .details-item
    .details-text
    .pay-resume
    .pay-info {
    font-size: 10px;
  }
  .check-content .amount-resume {
    font-size: 14px;
  }
  .check-content .amount-resume .total {
    font-size: 14px;
  }
  .is-button-primary {
    font-size: 14px;
  }
}
@media (max-width: 560px) {
  .check-content .subtitle-content {
    width: 100%;
  }
  .subtitle-content .subtitle-resumen {
    font-size: 12px;
  }
  .check-content .subtitle-content .resume-item .resume-text .credit-info {
    font-size: 8px;
  }
  .check-content .subtitle-content .resume-item .resume-text .fee-info {
    font-size: 8px;
  }
  .check-content
    .subtitle-content
    .details-item
    .details-text
    .pay-resume
    .fee-info {
    font-size: 8px;
  }
  .check-content
    .subtitle-content
    .details-item
    .details-text
    .pay-resume
    .pay-info {
    font-size: 8px;
  }
  .check-content .amount-resume {
    font-size: 12px;
  }
  .check-content .amount-resume .total {
    font-size: 12px;
  }
  .is-button-primary {
    width: 70%;
    font-size: 12px;
  }
}
@media (max-width: 430px) {
  .text-aling-center {
    font-size: 20px;
  }
}
@media (max-width: 420px) {
  .check-content .subtitle-content .details-item .details-text {
    width: 90%;
  }
  .check-content .subtitle-content .details-item .details-text .pay-resume {
    width: 40%;
  }
  .check-content .subtitle-content .resume-item .resume-text {
    width: 90%;
  }
  .check-content
    .subtitle-content
    .details-item
    .details-text
    .pay-amount
    .fee-info {
    margin-left: 0px;
  }
  @media (max-width: 340px) {
    .check-content .subtitle-content .details-item .details-text .pay-resume {
      width: 50%;
    }
  }
}
</style>
